export const trustClients = [
  {
    title: 'Sonnel',
    logo: 'http://media.elker.com/b37b1640-3416-483f-9075-bd33f9504174.webp',
    logoStyle: 'max-width: 120px;',
    slug: 'sonnel',
    url: 'https://sonnel.com.au/',
    // partnershipText: 'Sonnel has partnered with Elker to provide a safe space for people to speak up about anything.',
    heroTitle: 'Sonnel wants people to feel safe to speak up about anything',
    showTogetherWithElker: true,
    channels: [
      {
        title: 'Manager / Leader',
        description: '<p>The best path for Team members is to speak directly to your Manager / Leader.</p>'
      },
      {
        title: 'Tell Me Anything',
        description: '<p>A secure pathway with an option of anonymity with two way chat and your choice of contact including P&C. Includes anonymity, 2-way chat.</p>'
      },
      {
        title: 'CEO Connect',
        description: '<p>A secure pathway for guests and contractors to directly raise concerns, or provide feedback, directly to the CEO. Includes anonymity, 2-way chat.</p>'
      },
      {
        title: 'Whistleblowing',
        description: `<p>A secure and confidential pathway to raise concerns about corrupt, illegal or unethical conduct, including anonymity, 2-way chat and access to an external, independent contact (Resolve Advisors).</p>`,
        badge: 'https://elker.b-cdn.net/badges/Resolve-Advisors-Badge-Managed-By.png',
        badgeAlt: 'Whistleblowing Managed by Resolve Advisors'
      },
    ]
  },
  {
    title: 'Elker',
    logo: 'https://media.elker.com/c6550a87-fa98-49f7-bcfd-da86461f66b6.webp',
    logoStyle: 'max-width: 120px;',
    slug: 'elker',
    url: 'https://elker.com/',
    channels: [
      {
        title: 'Whistleblowing',
        description: 'A secure channel for people to raise concerns about unethical or illegal activities confidentially and with the option of anonymity.'
      },
      {
        title: 'CEO Connect',
        description: 'A secure channel for employees to confidentially and anonymously raise concerns, seek support or provide feedback directly to the CEO.'
      }
    ]
  },
  {
    title: 'Demo Company',
    logo: 'https://media.elker.com/52f1a5fe-aa39-46c9-a5a1-b6515b90fcda.png',
    logoStyle: 'max-width: 120px;',
    slug: 'demo',
    url: 'https://elker.com/',
    channels: [
      {
        title: 'Tell Me Anything',
        description: 'A channel to offer feedback or speak up about a concern with the option of anonymity.'
      },
      {
        title: 'Psychosocial hazard management',
        description: 'Identify psychosocial hazards before they cause harm, providing data-driven insights to protect worker well-being.'
      },
      {
        title: 'CEO Connect',
        description: 'A secure channel for employees to confidentially and anonymously raise concerns, seek support or provide feedback directly to the CEO.'
      },
      {
        title: 'Whistleblowing',
        description: 'A secure channel for people to raise concerns about unethical or illegal activities confidentially and with the option of anonymity.'
      },
      {
        title: 'Public Interest Disclosure',
        description: 'A secure channel for people to raise concerns about unethical or illegal activities confidentially and with the option of anonymity.'
      }
    ]
  }
]
